import { useTheme } from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import ScoreInfo from "features/newMarketplace/common/ScoreInfo";
import Modal from "common/Modal/Modal";
import { MarketplaceSubGroup } from "@shared/types";
import { usePageSize } from "common/Home/PageWrapper/PageSizeProvider.tsx";

interface ScoreModalProps {
  open: boolean;
  closeModal: () => void;
  group?: MarketplaceSubGroup;
  loading?: boolean;
}

const ScoreModal = ({ open, closeModal, group, loading }: ScoreModalProps) => {
  const { height: pageHeight } = usePageSize();
  const { isNewLook } = useTheme();
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);

  return (
    <Modal
      open={open}
      title={isNewLook ? t("score.title") : undefined}
      centered={isNewLook}
      destroyOnHidden={isNewLook}
      onCancel={closeModal}
      footer={false}
      styles={{
        body: {
          overflow: "auto",
          maxHeight: isNewLook
            ? "min(640px, calc(100dvh - 140px))"
            : pageHeight
            ? pageHeight * 0.9
            : 600,
          ...(isNewLook ? { padding: "4px 24px 24px" } : {}),
        },
      }}
    >
      <ScoreInfo group={group} loading={loading} hideTitle={isNewLook} />
    </Modal>
  );
};

export default ScoreModal;
